module.exports = __webpack_public_path__ + "img/promotion.e0b842cf.jpg";